// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ReasonLeaveOrganization_wrapper__1qA2Z","buttons":"ReasonLeaveOrganization_buttons__3DubL"};